import { render, staticRenderFns } from "./NotGoogleTip.vue?vue&type=template&id=4681ca70&scoped=true&"
import script from "./NotGoogleTip.vue?vue&type=script&lang=js&"
export * from "./NotGoogleTip.vue?vue&type=script&lang=js&"
import style0 from "./NotGoogleTip.vue?vue&type=style&index=0&id=4681ca70&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4681ca70",
  null
  
)

export default component.exports